import * as React from 'react'

interface Props {
    title: string
}
export const SectionTitle = (props: Props) => <h2 className="section-title">{props.title}</h2>
